// İSG uzmanı portalı — Kontrol aşaması enum yardımcıları (departman + onay durumu). Wire değerleri
// api-contract §31 / brief 095 §3'ten; çeviri (etiket) çağıran ekrandadır (i18n key =
// `permits.department.<value>` / `permits.departmentReview.status.<value>`). Durum `Tag` rengi
// (S33 Slice 4 — eski `Badge` kaldırıldı, paylaşılan `Tag`'in 4 renkli paleti) — literal renk yok.

import type { PermitDepartmentApprovalStatus, TagColor } from '@isgportal/shared';

/**
 * Departman onay durumu `Tag` rengi (brief 095 §3): `Approved` yeşil (onayladı), `Rejected`
 * kırmızı (reddetti — izin Revision'a), `Pending` gri (bekliyor — plan §5.1, "sürüyor, kimse
 * suçlu değil"). Personel belge onay tonuyla (§15.4) aynı semantik — ayrımı etiket taşır.
 */
export function departmentApprovalTone(status: PermitDepartmentApprovalStatus): TagColor {
  switch (status) {
    case 'Approved':
      return 'green';
    case 'Rejected':
      return 'red';
    default:
      return 'gray';
  }
}
